(function () {
  var ITEMS = [
    { text: 'Home', href: '/' },
    { text: 'Products', href: '/collections/all' },
    { text: 'Reviews', href: '/pages/reviews' },
    { text: 'Contact', href: '/pages/contact' },
    { text: 'FAQ', href: '/pages/faq' },
    { text: 'Shipping Policy', href: '/pages/shipping-returns' },
    { text: 'Return Policy', href: '/pages/shipping-returns' }
  ];

  function isAlreadyFixed(list) {
    return list.children.length === ITEMS.length && list.textContent.indexOf('FAQ') !== -1;
  }

  function buildMobileMenu() {
    var navs = document.querySelectorAll('.menu-drawer__navigation');
    navs.forEach(function (nav) {
      var list = nav.querySelector('ul.menu-drawer__menu');
      if (!list) return;
      if (isAlreadyFixed(list)) return;

      var html = ITEMS.map(function (item) {
        return '<li class="menu-drawer__list-item--flat">' +
          '<a href="' + item.href + '" class="menu-drawer__menu-item menu-drawer__menu-item--mainlist menu-drawer__animated-element focus-inset">' +
          '<span class="menu-drawer__menu-item-text wrap-text">' + item.text + '</span>' +
          '</a></li>';
      }).join('');

      list.innerHTML = html;
    });
  }

  buildMobileMenu();

  var mo = new MutationObserver(function () {
    buildMobileMenu();
  });
  mo.observe(document.body, { childList: true, subtree: true });

  var tries = 0;
  var poll = setInterval(function () {
    buildMobileMenu();
    tries++;
    if (tries > 40) clearInterval(poll);
  }, 200);

  document.addEventListener('shopify:section:load', buildMobileMenu);
})();
